var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6172-22.387-50-50-50h-300c-27.6133 0-50 22.3828-50 50v380c0 27.613 22.3867 50 50 50h239.996l110.004-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#277cb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6172 22.3867-50 50-50h300c27.613 0 50 22.3828 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0625-17.945-40-40-40h-300c-22.0547 0-40 17.9375-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#236e9c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.352 384.973 96.793-96.793v96.793z",
    fill: "#236e9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450 370h-70c-27.613 0-50 22.387-50 50v70h120z",
    fill: "#93bdd8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m108.281 407.328v-14.765h4.832c2.082 0 3.86.746 5.344 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.836 4.16-2.508 5.449-1.668 1.289-4.043 1.934-7.117 1.934zm-12.1716 10.371h19.7306c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.879-7.156 4.879-12.199 0-3.308-.801-6.453-2.399-9.422-1.597-2.976-4.004-5.195-7.226-6.66-3.223-1.465-5.977-2.226-8.262-2.285l-7.207-.176v-22.324h-12.3476z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 412.473-7.734-8.485c-4.071 2.403-7 3.606-8.789 3.606-1.375 0-2.563-.524-3.559-1.559-.996-1.039-1.492-2.281-1.492-3.715 0-2.843 2.578-5.304 7.73-7.382 3.782-1.614 6.637-3.075 8.571-4.372 1.933-1.308 3.55-3.113 4.855-5.429 1.305-2.313 1.957-4.821 1.957-7.516 0-4.949-1.996-9.258-6-12.918-3.996-3.664-8.723-5.492-14.172-5.492-5.976 0-11.879 2.809-17.711 8.434l8.176 9.539c3.66-3.782 7.09-5.668 10.281-5.668 1.496 0 2.934.664 4.309 1.992 1.379 1.332 2.066 2.726 2.066 4.187 0 3.008-3.179 5.664-9.539 7.961-3.633 1.321-6.211 2.563-7.73 3.719-1.528 1.156-2.809 2.844-3.844 5.059-1.047 2.207-1.562 4.472-1.562 6.789 0 5.125 1.667 9.285 5.007 12.48 3.34 3.192 7.707 4.789 13.098 4.789 6.387 0 11.746-2.008 16.082-6.019",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.723 406.801v-35.641h4.922c5.093 0 9.285 1.395 12.566 4.176 3.281 2.785 4.922 7.43 4.922 13.934 0 3.777-.789 7.121-2.371 10.035-1.582 2.918-3.879 4.894-6.875 5.937-3.008 1.039-5.871 1.559-8.598 1.559zm-12.528 10.898h19.688c8.41 0 15.176-2.652 20.305-7.953 5.125-5.301 7.691-12.289 7.691-20.961 0-8.703-2.649-15.676-7.934-20.918-5.293-5.246-12.328-7.867-21.117-7.867h-18.633z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320 150v90h-120v-90zm30-15c0-8.281-6.715-15-15-15h-150c-8.285 0-15 6.719-15 15v120c0 8.285 6.715 15 15 15h150c8.285 0 15-6.715 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260 85c0-8.2812-6.715-15-15-15h-120c-8.285 0-15 6.7188-15 15v80c0 8.281 6.715 15 15 15h120c8.285 0 15-6.719 15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 200h-40v20h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 180v40h20v-40z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsd);
export default __webpack_public_path__ + "static/media/psd.dc82b380e437aacf78cc9ddd3f7c59d0.svg";
export { ForwardRef as ReactComponent };